/**
 * SiteConfirmationBox.js
 *
 * Renders a confirmation box based on the status of the selected site.
 * It shows different cards for active, inactive, or not-found sites.
 */
import React from 'react';
import PropTypes from 'prop-types';
import SiteActiveCard from './SiteActiveCard';
import SiteInactiveCard from './SiteInactiveCard';
import SiteNotFoundCard from './SiteNotFoundCard';

SiteConfirmationBox.propTypes = {
  siteData: PropTypes.object.isRequired,
};

/**
 * Component for confirming the selected site.
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element|null} The rendered confirmation card.
 */
function SiteConfirmationBox(props) {
  const { siteData } = props;
  // Active site (green)
  if (siteData.type === 'Site' && siteData.isActive) {
    return (
      <SiteActiveCard
        siteData={siteData}
      />
    );
  }

  // Inactive DB site (blue)
  if (siteData.type === 'Site' && !siteData.isActive) {
    return (
      <SiteInactiveCard
        siteData={siteData}
      />
    );
  }

  // Not in database (blue) — user explicitly said "none of these" or it's a potential site
  if (siteData.type === 'PotentialSite') {
    return (
      <SiteNotFoundCard
        siteData={siteData}
      />
    );
  }

  return null;
}

export default SiteConfirmationBox;
